<template>
<div>
  <div @click="showFindings = !showFindings" class="checkpoint-intro">
    <columns class="is-mobile">
      <column>
        <h4 class="title is-5">{{ checkpoint.value }}</h4>
      </column>
      <column class="is-narrow">
        <span
          class="tag is-medium"
          :class="{
            'is-success': isCompliant,
            'is-danger': !isCompliant,
          }">
          {{ isCompliant ? 'Compliant' : `${nonCompliantFindings.length} Findings` }}
        </span>
      </column>
    </columns>
  </div>

  <div class="mt-3 box" v-if="showFindings">
    <div 
      v-for="finding in nonCompliantFindings" 
      :key="finding.id">
        <div>
          <router-link 
            :to="{
              name: 'route-manager',
              params: {
                app: audit.app_id,
                environment: audit.environment_id,
                route: finding.finding.findable.id
              }
            }">
            {{ finding.finding.findable.method }} {{ finding.finding.findable.uri }}
          </router-link>
        </div>
    </div>
  </div>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  props: {
    checkpoint: {
      type: Object,
      default: () => ({})
    },
    findings: {
      type: Array,
      default: () => ([])
    }
  },

  data: () => ({
    showFindings: false
  }),

  computed: {
    isCompliant() {
      return this.nonCompliantFindings.length === 0
    },
    nonCompliantFindings() {
      return this.findings.filter(finding => finding.is_compliant === false)
    },
    ...mapGetters('audit', [
      'audit',
    ])
  }

}
</script>